module.exports = __webpack_public_path__ + "static/media/logo-faint.0da12da8.png";